import React from 'react';
import { withStyles } from "@mui/styles";
import {Button,} from '@mui/material';
import {CheckIcon, UncheckIcon} from "../../../helpers/Icons";

const styles = {
  toolbarButton: {
    padding: '5.1px 10.2px',
    fontSize: '0.7225em',
    height: '34px',
    backgroundColor: '#ffffff',
    color: 'rgba(0, 0, 0, 0.87)',
    borderColor: 'rgba(0, 0, 0, 0.23)',
    '& span:first-child':{
      marginLeft: '-3.4px',
      marginRight: '6.8px'
    },
    '& svg':{
      width: '1em',
      height: '1em',
    }
  },
};

function SelectAllControl(props) {
  const {selectAllState, onSelectAllClick, classes} = props;

  return (
    <Button variant="outlined"
      id="dataSelectToggle"
      className={classes.toolbarButton}
      onClick={onSelectAllClick}
      startIcon={selectAllState === 1 ? <UncheckIcon /> : <CheckIcon />}
    >
      Select {selectAllState === 1 ? "None" : "All"}
    </Button>)
}

export default withStyles(styles)(SelectAllControl);
